<template>
  <collapsible-list
    :options="collapsibleListItems"
    icon="account"
    :title="$t('Cuenta')"
    class="navbar-item "
  />
</template>

<script>
import { mapGetters } from 'vuex'
import CollapsibleList from '@/components/common/CollapsibleList'
export default {
  name: 'AccountInfoCollapsibleList',
  components: { CollapsibleList },
  computed: {
    ...mapGetters('user', ['subscriptionData']),
    collapsibleListItems() {
      return [
        {
          label: 'Reserva',
          check: this.subscriptionData.deposit ? 'check' : 'close',
          value: null,
          valueUrl: null
        },
        {
          label: 'Información KYC',
          check: this.subscriptionData.kycInformation ? 'check' : 'close',
          value: this.subscriptionData.kyc
            ? this.subscriptionData.kyc.name
            : null,
          valueUrl: this.subscriptionData.kyc
            ? this.subscriptionData.kyc.url
            : null
        },
        {
          label: 'Comité de admisiones',
          check: this.subscriptionData.admissionsComittee ? 'check' : 'close',
          value: this.subscriptionData.admissionDate ? this.subscriptionData.admissionDate : null,
          valueUrl: null
        },
        {
          label: 'NDA',
          check: this.subscriptionData.ndaDraft ? 'check' : 'close',
          value: this.subscriptionData.signedNDA
            ? this.subscriptionData.signedNDA.name
            : null,
          valueUrl: this.subscriptionData.signedNDA
            ? this.subscriptionData.signedNDA.url
            : null
        },
        {
          label: 'Draft contrato',
          check: this.subscriptionData.contractDraft ? 'check' : 'close',
          value: this.subscriptionData.signedContract
            ? this.subscriptionData.signedContract.name
            : null,
          valueUrl: this.subscriptionData.signedContract
            ? this.subscriptionData.signedContract.url
            : null
        },
        {
          label: 'Tipo de licencia',
          check: null,
          value: this.subscriptionData.subscription,
          valueUrl: null
        },
        {
          label: 'Subscripción activa hasta',
          check: null,
          value: this.subscriptionData.expirationDate,
          valueUrl: null
        }
      ]
    }
  },
  mounted() {
    console.log(this.subscriptionData)
  }
}
</script>
